import './rawDataExplorer.css';
import React, { useEffect, useState } from 'react';
import connector from '../../connector/connector';
import AdminHeader from '../../components/adminHeader/adminHeader';
import { useNavigate } from 'react-router-dom';
import BannerImage from '../../components/bannerImage/bannerImage';
import Footer from '../../components/footer/footer';
import utilities from '../../utils/utils';

const RawDataExplorer = () => {

    const navigate = useNavigate();

    if (!localStorage.getItem('adminTokenTime') || utilities.isdateOlderThan30Minutes(localStorage.getItem('adminTokenTime'))) {
        navigate('/admin');
    }

    const [rawData, setRawData] = useState([]);
    const [singleRecordType, setSingleRecordType] = useState('');
    const [singleRecordId, setSingleRecordId] = useState('');
    const [singleRecordOutput, setSingleRecordOutput] = useState(null);
    // const [fetchedRecord, setFetchedRecord] = useState(null);

    useEffect(() => {

    }, []);



    const fetchSingleRecord = async () => {
        let record = null;
        try {
            if (singleRecordType === 'question') {
                record = await connector.getQuestionById(singleRecordId);
            } else if (singleRecordType === 'answer') {
                record = await connector.getAnswerById(singleRecordId);
            } else if (singleRecordType === 'response') {
                record = await connector.getResponseById(singleRecordId);
            } else if (singleRecordType === 'assessment') {
                record = await connector.getAssessmentById(singleRecordId);
            } else {
                alert('Please select a valid record type.');
                return;
            }
            setSingleRecordOutput(JSON.stringify(record, null, 2));
        } catch (error) {
            setSingleRecordOutput(`Error fetching record: ${error.message}`);
        }
    };

    return (
        <div className="raw-data-explorer-wrapper">
            <AdminHeader></AdminHeader>
            <BannerImage text="Raw Data Explorer"></BannerImage>
            <h2>GET single <select onChange={(e) => setSingleRecordType(e.target.value)} value={singleRecordType}>
                <option>SelectRecord type</option>
                <option value='question'>Question</option>
                <option value='answer'>Answer</option>
                <option value='response'>Response (not ready for use)</option>
                <option value='assessment'>Assessment</option>

            </select>record by ID: <input placeholder='Enter record ID' value={singleRecordId} onChange={(e) => setSingleRecordId(e.target.value)}></input>
                <button onClick={fetchSingleRecord}>Fetch Record</button>
            </h2>

            <textarea rows={20} cols={100} value={singleRecordOutput} readOnly style={{height: 'fit-content'}}></textarea>





        </div>
    );
};

export default RawDataExplorer;